const routes = [
  {
    path: '/historyAlarm',
    name: 'historyAlarm',
    component: () => import('@src/modules/historyAlarm/view/HistoryAlarm'),
    meta: {
      requireAuth: true,
      routerAlive: true
    }
  }
]

export default routes
